export default "__VITE_ASSET__e7eb3d0d__"